import React, { useEffect, useState } from "react";
import { useSelectedZone } from "../../../hooks/useSelection";
import { createComponentAsync } from "../../bottom-menu/menu-loader";
import { BottomMenuIds } from "../../bottom-menu/paths";
import { useErrorHandling } from "../../../hooks/useErrorHandling";

import "./top-menu.css";
import { TextTopMenu } from "../text-top-menu/text-top-menu";
import { SymbolTopMenu } from "../symbol-top-menu/symbol-top-menu";
import { useFeatureFlagToggle } from "../../../hooks/useFeatureFlags";
import { PhotoTopMenu } from "../photo-top-menu/photo-top-menu";

export const TopMenu = () => {
	const selectedZone = useSelectedZone();
	const { createFatalErrorHandler } = useErrorHandling();

	const allowDesktopPhotosMenus = useFeatureFlagToggle("allowDesktopPhotoMenus");
	const allowDesktopSymbolMenus = useFeatureFlagToggle("allowDesktopSymbolMenus");

	const [component, setComponent] = useState<React.ReactNode>(null);

	useEffect(() => {
		async function getMenuComponent() {
			let newComponent: React.JSX.Element | null = null;
			let bottomMenuId = null;

			// No selection
			if (selectedZone === undefined) {
				bottomMenuId = BottomMenuIds.None;
			}

			// Photo zone ?
			else if (
				eXpress.core.isPhotoZone(selectedZone) &&
				selectedZone.isZoneForPhotoSourceType("photo")
			) {
				newComponent = allowDesktopPhotosMenus ? <PhotoTopMenu /> : null;
			}

			// Text zone ?
			else if (eXpress.core.isAnyTextZone(selectedZone)) {
				// TODO: Load async, bundle in text menu file
				newComponent = <TextTopMenu />;
			}

			// Symbol zone ?
			else if (eXpress.core.isSymbolZone(selectedZone)) {
				newComponent = allowDesktopSymbolMenus ? <SymbolTopMenu /> : null;
			}

			// QR zone ?
			else if (
				eXpress.core.isPhotoZone(selectedZone) &&
				selectedZone.isZoneForPhotoSourceType("qr")
			) {
				bottomMenuId = BottomMenuIds.Qr;
			}

			// For BottomMenu based top menu's
			// TODO: delete
			if (bottomMenuId !== null) {
				// Wrap with bottom-menu class for styling
				const comp = await createComponentAsync(bottomMenuId);
				newComponent = comp ? <div className="bottom-menu">{comp}</div> : null;
			}
			setComponent(newComponent);
		}

		getMenuComponent().catch(createFatalErrorHandler());
	}, [allowDesktopPhotosMenus, allowDesktopSymbolMenus, createFatalErrorHandler, selectedZone]);

	return <div className="top-menu">{component}</div>;
};
